module.exports = __webpack_public_path__ + "img/whatsnew-scribble_cn.fc4136c.jpg";